import { StyleSheet } from 'react-native'
import { colorList } from 'utils/colors'
import { ThemedValues } from 'styles/themed'

export const navigationStyles = StyleSheet.create({
	bottomNavigationContainer: {
		position: 'absolute',
		zIndex: 20,
		bottom: 0,
		left: 0,
		right: 0,
		width: '100%',
		height: 'auto',
		backgroundColor: 'transparent',
		marginHorizontal: 0,
		marginBottom: 0,
		paddingVertical: 0,
		borderTopWidth: 0,
		paddingTop: 8,
		paddingHorizontal: 12,
	},
	bottomNavigationContainerVertical: {
		position: 'relative',
		zIndex: 0,
		width: 112,
		height: '100%',
		backgroundColor: colorList.WHITE.primary,
		paddingHorizontal: 8,
		paddingVertical: 12,
		borderTopWidth: 0,
		borderRightWidth: 1,
		borderRightColor: colorList.PRIMARY.lighter,
	},
	appIconContainer: {
		alignItems: 'center',
		paddingTop: 10,
	},
	appIcon: {
		width: 52,
		height: 52,
		borderRadius: 12,
	},
	bottomNavigation: {
		paddingTop: 0,
		paddingBottom: 0,
		bottom: 0,
		backgroundColor: 'transparent',
	},
	bottomNavigationFloatingShadow: {
		borderRadius: 30,
		backgroundColor: 'transparent',
		shadowColor: '#17213b',
		shadowOffset: { width: 0, height: 8 },
		shadowOpacity: 0.16,
		shadowRadius: 18,
		elevation: 12,
	},
	bottomNavigationFloating: {
		position: 'relative',
		overflow: 'hidden',
		borderRadius: 30,
		borderWidth: 1,
		borderColor: 'rgba(255, 255, 255, 0.82)',
		backgroundColor: 'rgba(255, 255, 255, 0.18)',
		padding: 4,
	},
	bottomNavigationHighlight: {
		position: 'absolute',
		top: 0,
		left: 22,
		right: 22,
		height: 1,
		backgroundColor: 'rgba(255, 255, 255, 0.95)',
	},
	bottomNavigationIcon: {
		color: colorList.BLACK.light,
		marginBottom: 4,
	},
	bottomNavigationBadge: {
		right: -15,
		top: -5
	},
	bottomNavigationIndicator: {
		position: 'absolute',
		height: 56,
		//top: 3,
		borderRadius: ThemedValues.borderRadius,
		opacity: 0.2
	}
});
